import './AddressPicker.scss';
import Component from './AddressPicker.js';
export default Component;
